import React from 'react'
import UpdateEntryForm from "../components/UpdateEntryForm"

function UpdateEntryPage() {
  return (
    <div className="create-entry-page-div">
        <div className='create-entry-form-div'>
          <UpdateEntryForm />
        </div>
    </div>
  )
}

export default UpdateEntryPage